import {
  EmptyState,
  EmptyStateContainer,
} from 'module/ui/components/atoms/empty-state/empty-state';
import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import { faPage, faPlus } from '@fortawesome/pro-regular-svg-icons';
import { EmptyState as RocketlaneEmptyState, Icon } from '@rocketlane/ui';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

type CompanyPageTemplatesEmptyStateProps = {
  onPrimaryAction?: VoidFunction;
};

const NoTemplatesRoot = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding: var(--spacing-09) var(--spacing-08);
  background-color: var(--white-100);
`;

export const CompanyPageTemplatesNoSearchMatchState = ({
  onPrimaryAction,
}: CompanyPageTemplatesEmptyStateProps) => {
  return (
    <EmptyStateContainer>
      <EmptyState
        image={
          <FontAwesomeIcon
            icon={faPage}
            size={50}
            iconSize={40}
            color="transparent"
          />
        }
        title={
          <FormattedMessage id="company_page_templates.empty_state.no_search_results.title" />
        }
        message={
          <FormattedMessage id="company_page_templates.empty_state.no_search_results.message" />
        }
        primaryCTA={
          <EmptyState.CallToAction.Primary
            type="primary"
            onClick={onPrimaryAction}
          >
            <FormattedMessage id="clear_search" />
          </EmptyState.CallToAction.Primary>
        }
      />
    </EmptyStateContainer>
  );
};

export const CompanyPageTemplatesNoTemplatesState = ({
  onPrimaryAction,
}: CompanyPageTemplatesEmptyStateProps) => {
  return (
    <NoTemplatesRoot>
      <RocketlaneEmptyState
        icon={{ icon: faPage }}
        message={
          <FormattedMessage id="company_page_templates.empty_state.no_templates.title" />
        }
        primaryAction={
          onPrimaryAction
            ? {
                leftIcon: <Icon icon={faPlus} size=".75x" />,
                onClick: onPrimaryAction,
                children: (
                  <FormattedMessage id="company_page_templates.empty_state.no_templates.cta" />
                ),
              }
            : undefined
        }
      />
    </NoTemplatesRoot>
  );
};
